import ButtonBack from "components/ButtonBack/ButtonBack";
import ButtonClose from 'components/ButtonClose/ButtonClose';
import User from "components/StartConversation/components/User/User";
import { __app } from "Utils/App";
import { __callbacks } from "Utils/Callbacks/Callback";
import { AppContext, ChatContext, ConfigContext } from "Utils/Contexts";
import { AppState, ChatState } from "Utils/Enums";
import { useContext, useEffect, useState } from "react";
import styles from "./HeaderChat.module.scss";


export default function HeaderChat() {


  const appStateContext = useContext(AppContext);
  const chatStateContext = useContext(ChatContext);
  const configContext = useContext(ConfigContext);
  const [hideClass, setHideClass] = useState("");
  const [classHeaderSmall, setClassHeaderSmall] = useState("");
  const [backState, setBackState] = useState(AppState.home);

  useEffect(() => {
    if (appStateContext === AppState.chat) {
      setHideClass("");
      if(chatStateContext === ChatState.newConversation) {
        setClassHeaderSmall("");
      }
    }
    else {
      setHideClass(styles["hide-right"]);
    }
  }, [appStateContext, chatStateContext]);
  

  useEffect(() => {
    __callbacks.onSetChatHeaderSmall(data => {
      setClassHeaderSmall("height-header-chat-small");
    });

    __callbacks.onStartNewChat((data) => {
      setBackState(data.backState);
    });
      __callbacks.onContinueConversation(data => {
      setBackState(data.backState);
    });
  }, []);

  return (
    <div className={`${styles.container} ${hideClass} ${__app.getClassHeightHeader(AppState.chat)} ${classHeaderSmall}`}>
      <div className={styles["container-content"]}>
        <div className={styles["container-btn-back"]}>
          <ButtonBack backState={backState}></ButtonBack>
        </div>
        <div className={styles["container-title"]}>
          <div className={`title ${styles[classHeaderSmall]}`}></div>
          <p className={`${styles["message"]} ${styles[classHeaderSmall]}`}>{configContext.header.message}</p>
          <div>
              
          </div>
          
        </div>
        <div className={`${styles["container-btn-close"]}`}>
                    <ButtonClose></ButtonClose>
        </div>
      </div>
    </div>

  )
}
